import { wireNavigationMenu, wirePartnerIntakeLinks, wireStaticIcons } from "./ui";

wireStaticIcons();
wireNavigationMenu();
void wirePartnerIntakeLinks();
